import React from 'react';
import { useSelector } from 'react-redux';

export default function Bio() {
  const curIndex = useSelector((state) => state.data.curIndex);
  const selectedLocation = useSelector((state) => state.data.selectedLocation);

  const style = {
    display: curIndex === -1 ? 'none' : 'block',
  };

  return (
    <div className="bio-wrap" style={style}>
      <div className="siteHeading">{selectedLocation?.location}</div>
      <div className="siteType">{selectedLocation?.type}</div>
      <p>{selectedLocation?.bio}</p>
      <div className="source">SOURCE: {selectedLocation?.source}</div>
    </div>
  );
}
